import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { getDefaultConfig, RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { WagmiProvider, http, createStorage } from 'wagmi'
import { okxWallet } from '@rainbow-me/rainbowkit/wallets'
import { arbitrumSepolia, mantleSepoliaTestnet } from 'wagmi/chains'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { EthersProvider, EthersAutoReload } from './context/EthersContext.jsx'

const cuurent_projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID?.trim();

const rpcUrl = process.env.REACT_APP_RPC_URL?.trim();
const mantleRpc = process.env.REACT_APP_MANTLE_RPC_URL?.trim();
const arbRpc = process.env.REACT_APP_ARB_RPC_URL?.trim();
const mantleIconUrl = (typeof window !== 'undefined' ? window.location.origin : '') + '/icons/mantle.svg';
const mantleChain = {
  ...mantleSepoliaTestnet,
  name: 'Mantle Sepolia',
  iconUrl: mantleIconUrl,
  iconBackground: '#0f172a',
};
const storage = typeof window !== 'undefined' ? createStorage({ storage: window.localStorage, key: 'wagmi.around' }) : undefined;
const config = getDefaultConfig({
  appName: 'HyperLink',
  projectId: cuurent_projectId,
  chains: [mantleChain, arbitrumSepolia],
  transports: {
    [mantleSepoliaTestnet.id]: http(mantleRpc || 'https://rpc.sepolia.mantle.xyz'),
    [arbitrumSepolia.id]: http(arbRpc || rpcUrl || 'https://arb-sepolia.g.alchemy.com/v2/demo'),
  },
  wallets: [
    {
      groupName: 'Preferred',
      wallets: [okxWallet],
    },
  ],
  ssr: false, // true if your dapp uses server-side rendering.
  storage,
});
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider coolMode={true}>
          <EthersProvider>
            <BrowserRouter>
              <EthersAutoReload />
              <App />
            </BrowserRouter>
          </EthersProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
